<template>
  <Page class="page-container--scrollable-table">
    <PageContent>
      <UnitsContext>
        <RouterView />
      </UnitsContext>
    </PageContent>
  </Page>
</template>

<script lang="ts" setup>
import UnitsContext from '@/components/deepadmin/units/UnitsContext.vue'
import Page from '@/components/page/Page.vue'
import PageContent from '@/components/page/PageContent.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.organization.units.title',
  },
})
</script>
